import { useId } from 'react';
import css from './faq.module.scss';

const questions = [
  {
    question: 'Як подати запит у службу цивільно-військового співробітництва?',
    answer:
      'На головній сторінці натисніть на кнопку "Подати запит до ЦВС". В відкритому модальному вікні оберіть тип запиту "Запити до ЦВС", в меті запиту оберіть необхідний вам запит та натисніть кнопку "Далі". У відкритому модальному вікні натисніть кнопку "Сформувати лист", у відкритому почтовому клієнті сформуйте лист і надішліть його.'
  },
  {
    question: 'Як порекомендувати послугу на сайт?',
    answer:
      'На сторінці послуг натисніть на кнопку "Запропонувати послугу". У відкритому модальному вікні заповніть необхідні поля та натисніть надіслати. Після обробки нашими операторами з вами зв`яжуться для обговорення подальших кроків.'
  },
  {
    question: 'Як поскаржитися на послугу?',
    answer:
      'У випадку якщо послуга неактуальна або надана неякісно ви можете залишити скаргу на цю послугу. Для цього вам необхідно навести курсор в правий верхній кут відповідної послуги і натиснути на кнопку "⋮", після чого в модальному вікні обрати варіант "Поскаржитись" та обрати тип скарги, а також описати скаргу та натиснути кнопку  "Надіслати". Після обробки нашими операторами послуга буде виправлена або з Вами зв`яжуться для обговорення подальших кроків.'
  },
  {
    question: 'Як залишити відгук про платформу?',
    answer:
      'У верхній частині сайту натисніть кнопку "Залишити відгук". У відкритому модальному вікні заповніть необхідні поля та натисніть надіслати. Після обробки нашими операторами за потреби з Вами зв`яжуться для обговорення подальших кроків.'
  }
];

export default function Faq() {
  const faqKey = useId();
  return (
    <div className={css.faq}>
      <div className={css.title}>Питання та відповіді</div>
      <div className={css.questions}>
        {questions.map((q, i) => (
          <details key={faqKey + i}>
            <summary>{q.question}</summary>
            <section className={css.answer}>{q.answer}</section>
          </details>
        ))}
      </div>
    </div>
  );
}
